import { requestErrorMessage } from '../../utils/requestError';

// Only locally authored envelope errors may retain their message. Backend and transport prose is
// always replaced with fixed application text before it reaches the page or logs.
const localResponseMessages = new WeakMap();

export function unwrap(res, what) {
  const body = res?.data;
  const payload =
    body && typeof body === 'object' && !Array.isArray(body) && 'data' in body ? body.data : body;
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    const message = `The API did not return ${what}. This usually means the app is pointed at the wrong address.`;
    const error = new Error(message);
    localResponseMessages.set(error, message);
    throw error;
  }
  return payload;
}

export const errorText = (error, fallback) =>
  localResponseMessages.get(error) || requestErrorMessage(error, fallback);

export async function blobErrorText(error, fallback) {
  return errorText(error, fallback);
}

export const throttleAware = (error, fallback) =>
  error?.response?.status === 429
    ? 'This was checked less than a minute ago. It reads the whole QuickBooks company file, so it is limited to once a minute - try again shortly.'
    : errorText(error, fallback);
